import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Loading from 'xpi-black-ui/Base/Loading';
import { P } from 'xpi-black-ui/Base/Typography';
import ContentBox from 'xpi-black-ui/Base/ContentBox';

import Quotes from './compose/Quotes';
import ModalDialog from '../ModalDialog';

import { deleteQuote } from '../../service';
import { LoadQuotes, SetQuoteEdit } from '../../../../redux-flow/actions/custom-quotes';

function StoredOperations({ quotes, msg }) {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [quoteRemove, setQuoteRemove] = useState(undefined);

  const { loadingQuotes } = useSelector(({ CustomQuotes }) => CustomQuotes);

  useEffect(() => {
    if (loading && !loadingQuotes) {
      setLoading(false);
    }
  }, [loadingQuotes]);

  const loadQuotes = () => {
    dispatch(LoadQuotes());
  };

  const deleteQuoteView = (quote) => {
    deleteQuote({
      quote,
      beforeBack: () => setLoading(true),
      callBack: () => loadQuotes(),
    })
  };

  return (
    <>
      <ContentBox style={{ marginBottom: '24px' }}>
        <P style={{ textAlign: 'center' }}>
          {msg
            ? msg
            : 'As cotações armazenadas ficarão salvas na plataforma até 18h00 do dia da cotação.'
          }
        </P>
      </ContentBox>

      {!msg && (
        <ContentBox>
          {quotes.length > 0 ? (
            <Quotes
              quotes={quotes}
              deleteQuote={(quote) => setQuoteRemove(quote)}
              editQuote={(quote) => dispatch(SetQuoteEdit({ quote }))}
            />
          ) : (
            <P style={{ margin: '32px 0', textAlign: 'center' }}>Você não possui nenhuma cotação armazenada</P>
          )}


          <ModalDialog
            width="340px"
            height="auto"
            open={quoteRemove !== undefined}
            titlePrimaryButton="Excluir"
            titleSecondaryButton="Cancelar"
            onClose={() => setQuoteRemove(undefined)}
            title="Tem certeza de que deseja excluir essa cotação?"
            actionPrimaryButton={() => {
              deleteQuoteView(quoteRemove);
              setQuoteRemove(undefined);
            }}
          />

          {loading && <Loading text="Carregando..." fixed />}

        </ContentBox>
      )}
    </>
  );
}

export default StoredOperations;
